import Home from './components/Home'

// Sync route definition
export default Home
